"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosWrapper = void 0;
const axios_1 = __importDefault(require("axios"));
class AxiosWrapper {
    constructor(baseURL, bearerToken) {
        const config = {
            headers: {
                Authorization: `Bearer ${bearerToken}`,
                'CacheControl': 'no-cache',
                Pragma: 'no-cache'
            },
            baseURL: baseURL
        };
        this.axiosInstance = axios_1.default.create(config);
    }
}
exports.AxiosWrapper = AxiosWrapper;
